import React, { useState, useEffect } from 'react';
import styles from './HelpModal.module.css';
// ✅ WORKING PATTERN:
const API_BASE_URL = "https://final-project-5ar7.onrender.com";
 // ✅ centralized API

export default function HelpModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    priority: 'medium'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    if (!formData.name.trim() || !formData.email.trim() || !formData.subject.trim() || !formData.message.trim()) {
      setError('Please fill in all required fields');
      setIsSubmitting(false);
      return;
    }

    try {
      console.log('🔄 Submitting support ticket:', formData);

      // ✅ Correct endpoint: /api/support/submit-ticket
      const response = await fetch(`${API_BASE_URL}/api/support/submit-ticket`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          timestamp: new Date().toISOString(),
          status: 'open',
          source: 'homepage_help_button'
        })
      });

      console.log('📡 Response status:', response.status);
      const data = await response.json();
      console.log('📄 Response data:', data);

      if (response.ok && data.success) {
        setSubmitSuccess(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
          priority: 'medium'
        });

        setTimeout(() => {
          setSubmitSuccess(false);
          onClose();
        }, 3000);
      } else {
        setError(data.message || 'Failed to submit support ticket. Please try again.');
      }
    } catch (err) {
      console.error('❌ Network error submitting support ticket:', err);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setError('');
      setSubmitSuccess(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Need Help? Contact Support</h2>
          <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>

        {submitSuccess ? (
          <div className={styles.successMessage}>
            <div className={styles.successIcon}>✅</div>
            <h3>Support Ticket Submitted!</h3>
            <p>Thank you for contacting us. Our support team will get back to you within 24 hours.</p>
          </div>
        ) : (
          <form className={styles.helpForm} onSubmit={handleSubmit}>
            {error && <div className={styles.errorMessage}>❌ {error}</div>}

            <div className={styles.formGroup}>
              <label htmlFor="name">Full Name *</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address *</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject *</label>
              <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="priority">Priority</label>
              <select id="priority" name="priority" value={formData.priority} onChange={handleChange}>
                <option value="low">Low - General Question</option>
                <option value="medium">Medium - Account Issue</option>
                <option value="high">High - Trading Problem</option>
                <option value="urgent">Urgent - Can't Access Account</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message">Message *</label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows="5" required />
            </div>

            <div className={styles.formActions}>
              <button type="button" onClick={onClose} className={styles.cancelButton}>Cancel</button>
              <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
                {isSubmitting ? 'Submitting...' : 'Submit Ticket'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
